module.exports = __webpack_public_path__ + "img/img10.ff922561.png";